import React from 'react';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import { StyledImageContainer, StyledContainer, StyledHeading } from './CategoryTitleSection.styles.mjs';
import Image from 'next/image';
import { useTheme } from 'styled-components';

const CategoryTitleSection = ({ children, title, image }) => {
    const theme = useTheme();
    return (React.createElement("div", null,
        Boolean(image) && (React.createElement(StyledImageContainer, null,
            React.createElement(Image, { src: image, alt: title, fill: true, objectFit: "cover", unoptimized: true }))),
        React.createElement(StyledContainer, null,
            React.createElement(FlexContainer, { gap: "1rem", direction: "column" },
                React.createElement(StyledHeading, { tag: "h2", color: theme.colors.textColor }, title),
                children))));
};

export { CategoryTitleSection as default };
//# sourceMappingURL=CategoryTitleSection.mjs.map
